// extracted by mini-css-extract-plugin
module.exports = {"menu":"Navbar_menu__oxSgr","navbarIcon":"Navbar_navbarIcon__1VCVh","navLogout":"Navbar_navLogout__2yXSe"};